import { Reducer } from "redux";

// action types
export const SET_ARCHIVED_FILTER = "SET_ARCHIVED_FILTER";
export const SET_EXPIRED_FILTER = "SET_EXPIRED_FILTER";
export const SET_EMPTY_FILTER = "SET_EMPTY_FILTER";

//action creator types
export interface ISetArchivedFilterAction {
  type: typeof SET_ARCHIVED_FILTER;
  showArchived: boolean;
}
export interface ISetExpiredFilterAction {
  type: typeof SET_EXPIRED_FILTER;
  showExpired: boolean;
}
export interface ISetEmptyFilterAction {
  type: typeof SET_EMPTY_FILTER;
  showEmpty: boolean;
}

// action creators
export const setArchivedFilter = (showArchived: boolean): ISetArchivedFilterAction => ({
  type: SET_ARCHIVED_FILTER,
  showArchived,
});
export const setExpiredFilter = (showExpired: boolean): ISetExpiredFilterAction => ({
  type: SET_EXPIRED_FILTER,
  showExpired,
});
export const setEmptyFilter = (showEmpty: boolean): ISetEmptyFilterAction => ({
  type: SET_EMPTY_FILTER,
  showEmpty,
});

type IMedicineActions = ISetArchivedFilterAction | ISetExpiredFilterAction | ISetEmptyFilterAction;

export interface IMedicineState {
  showArchived: boolean;
  showExpired: boolean;
  showEmpty: boolean;
}

// reducer with initial state
export const initialMedicineState: IMedicineState = {
  showArchived: false,
  showExpired: false,
  showEmpty: false,
};

const medicineReducer: Reducer<IMedicineState, IMedicineActions> = (
  state = initialMedicineState,
  action: IMedicineActions,
) => {
  switch (action.type) {
    case SET_ARCHIVED_FILTER:
      return {
        ...state,
        showArchived: action.showArchived,
      };
    case SET_EXPIRED_FILTER:
      return {
        ...state,
        showExpired: action.showExpired,
      };
    case SET_EMPTY_FILTER:
      return {
        ...state,
        showEmpty: action.showEmpty,
      };
    default:
      return state;
  }
};

export default medicineReducer;
